<div>
  <div class="technicians-container" *ngIf="!loadingPaymentStatus">    
    <div *ngFor="let technician of technicians; let i = index;" style="margin-bottom: 16px;">
        <app-technicians-schedule [technician]="technician" [technicianID]="technician.TechnicianID" [fromDate]="fromDate"
          [toDate]="toDate" (updateDate)="updateDate($event)" (getUsers)="getUsers.emit()"
          [techniciansAllowed]="techniciansAllowed" [allocatedTechnicians]="allocatedTechnicians"></app-technicians-schedule>
    </div>
  </div>
</div>
